<template>
	<table class="audit-list" v-for="(item, index) in auditList" :key="index">
		<tr>
			<th>Action Id</th>
			<td>{{ item.id }}</td>
		</tr>
		<tr>
			<th>Operator Initials</th>
			<td :class="item.operatorInitials ? 'operator-id' : 'non-operator'">
				<span :style="getUserIconColors(item?.operatorUserId)">{{
					item?.operatorInitials ? item.operatorInitials : "Non-operator event"
				}}</span>
			</td>
		</tr>
		<tr>
			<th>Date</th>
			<td>{{ item.date }}</td>
		</tr>
		<tr>
			<th>Action</th>
			<td>{{ item.action }}</td>
		</tr>
		<tr>
			<th>Details/Notes</th>
			<td class="details">{{ item.details }}</td>
		</tr>
	</table>
</template>

<script>
export default {
	name: "UserAuditLogsTableMobile",
	inheritAttrs: false,
	props: {
		auditList: Array,
	},
	data() {
		return {};
	},
	methods: {
		getUserIconColors(userId) {
			let style = `background-color: #${this.generateUserIdColor(userId).background}; color: #${this.generateUserIdColor(userId).color}`;
			return style;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audit-list {
	width: 100%;
	text-align: left;
	border-collapse: collapse;
	margin-bottom: 2em;
}

.audit-list th,
.audit-list td {
	border: 1px #000 solid;
	padding: 5px 10px;
}

.audit-list th {
	width: 6em;
	color: #fff;
	background-color: #000;
}

.details {
	overflow-wrap: anywhere;
}

.non-operator {
	color: #004aa7;
}

.audit-list tr:nth-child(2n) {
	background-color: #bfbfbf;
}
</style>